<template>
  <div class="row">
    <!-- TOP BAR -->
    <div class="top-bar">
      <!-- Button trigger modal -->
      <div class="upper-link">
        <img src=".././assets/images/Note.svg" alt="">
        <a href="#noteModal" data-toggle="modal" data-target="#noteModal">
          <p>Add note</p>
        </a>
      </div>
      <div class="upper-link send-notification">
        <img src=".././assets/images/SMS.svg" alt="">
        <a href="#" @click="sendNotification">
          <p>Send notification</p>
        </a>
      </div>
      <div class="upper-link">
        <img src=".././assets/images/person-white.svg" alt="">
        <a href="#identifyModal" data-toggle="modal" data-target="#identifyModal">
          <p>Identify person</p>
        </a>
      </div>
      <div class="upper-link">
        <img src=".././assets/images/flag-white.svg" alt="">
        <a href="#" @click="flagEvent">
          <p>Flag</p>
        </a>
      </div>

      <div class="btn-back ml-auto" @click="redirectBack" v-if="showBackBtn">
        <a href="#" @click="redirect(`events`)"> <i class="fas fa-long-arrow-alt-left"></i> Back </a>
      </div>
    </div>

    <!-- Modals -->
    <div class="modal fade" id="noteModal" tabindex="-1" role="dialog" aria-labelledby="noteModalLabel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="noteModalLabel">Add note</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <textarea name="" id="" cols="50" rows="10" v-model="notes"></textarea>
          </div>
          <div class="modal-footer">
            <button type="button" @click="updateNote()" class="btn btn-primary my-btn" data-dismiss="modal">Save note</button>
          </div>
        </div>
      </div>
    </div>

    <identify-modal :item="item" alertPage="1" v-if="item" @identified="identified($event)" @create="user = $event; edit = true"/>
    <user-profile :user="user" @close="edit = false" @saved="userIdentified()" v-if="edit"/>

    <transition name="slide-fade">
      <div class="container-main right-container-allert" v-if="show">
        <!-- PERSON BIO -->
        <div class="person-bio-container" :style="{opacity: edit ? 0: 1}">
          <div class="row bio-header">
            <div class="col">
              <div class="avatar-image">
                <img :src="item.image_crop_path" class='mx-auto' alt="" :style="{ height: avataRimageHeight + 'px' }">
              </div>
              <div class="target-image" v-if="item.category==2">
                <img src=".././assets/images/square_green.svg" alt="" ref="targetImg">
                <p>CAM {{ item.camera_id }}</p>
              </div>
              <div class="target-image" v-else>
                <img src=".././assets/images/red_square.svg" class='mx-auto' alt="" ref="targetImg">
                <p>CAM {{ item.camera_id }}</p>
              </div>
            </div>

            <div class="col bio-status" v-if="item.category==2">
              <div class="row">
                <div class="identified-status-circle"></div>
              </div>
              <br>
              <div class="row">
                <p v-if="item.user">{{ item.user.first_name }} {{ item.user.last_name }}</p>
              </div>
              <div class="row identified-status">
                <p>Identified person</p>
              </div>
            </div>
            <div class="col bio-status" v-else>
              <div class="row">
                <div class="unidentified-status-circle"></div>
              </div>
              <br>
              <div class="row unidentified-status">
                <p>{{ item.user.first_name }} {{ item.user.last_name }} [{{ item.user.id }}]</p>
              </div>
            </div>
          </div>
          <div class="bio-container">
            <div class="bio-info">
              <p>Time</p>
              <p>{{ item.time_start }} - {{ item.time_end }}</p>
            </div>
            <div class="bio-info">
              <p>Event ID</p>
              <p>{{ item.id }}</p>
            </div>
            <div class="bio-info">
              <p>Location</p>
              <p>{{ item.camera ? item.camera.location.name : '' }}</p>
            </div>
            <div class="bio-info">
              <p>Note</p>
              <p v-text="item.notes"></p>
            </div>
          </div>

          <div class="row first-two-footage text-center mx-auto">
            <div class="footage-labels">
              <p>HD</p>
              <!-- <p>{{ item.room }}</p> -->
              <p><img src=".././assets/images/Thermo .svg" alt=""></p>
            </div>
            <div class="col-6">
              <img :src="item.image_path" alt="" @click="updateImageViewerSrc(item.image_path, 'normal')" class="clickable-img">
            </div>
            <div class="col-6">
              <img :src="item.thermal_image_path" alt="" @click="updateImageViewerSrc(item.thermal_image_path, 'thermo')" class="clickable-img" v-if="item.thermal_image_path">
              <img src=".././assets/images/img_thermo_2.png" alt="" class="clickable-img" @click="updateImageViewerSrc('.././assets/images/img_thermo_2.png', 'thermo', true)" v-else>
            </div>
          </div>
        </div>

        <!-- IMAGES CONTAINER -->
        <div class="image-container">
          <div class="pt-2">
            <div class="col-md-5">
              <button ref="zoomOut" @click="zoomOut" class="btn btn-zoom">-</button>
              <button ref="zoomReset" @click="zoomReset" class="btn btn-zoom">reset</button>
              <button ref="zoomIn" @click="zoomIn" class="btn btn-zoom">+</button>
            </div>
          </div>
          <div class="">
            <div class="zoomable-img-container allert-footage-container container">
              <div class="zoom" id="zoomContainer" ref="zoomContainer">
                <img :src="imageViewerSrc" id="zoomImg" ref="zoomImg">
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
  import 'wheelzoom';
  import IdentifyModal from '@/components/IdentifyModal';
  import UserProfile from '@/views/UserProfile';

  export default {
    name: 'AlertComponent',
    components: {
      IdentifyModal,
      UserProfile
    },
    props: {
      id: {
        default: null
      }
    },
    data() {
      return {
        edit: false,
        user: null,
        imageViewerSrc: '',
        zoomInit: false,
        zoomEl: '',
        show: false,
        avataRimageHeight: null,
        notes: '',
        showBackBtn: true,
        clicked: {
          normal: false,
          thermo: false
        }
      };
    },
    computed: {
      item() {
        return this.$store.state.alert.item;
      },
    },
    mounted() {
      this.getItem();
      this.notes = this.item.notes;
      // this.$nextTick(function () {
      // 	setTimeout(() => {
      // 		this.initZoom();
      // 	}, 1000);
      // })

      this.show = true;
    },
    destroyed() {
      this.show = false;
    },
    methods: {
      initZoom() {
        this.zoomEl = wheelzoom(this.$refs.zoomImg, { zoom: 0.10, });
      },
      zoomIn() {
        this.$refs.zoomImg.doZoomIn();
      },
      zoomOut() {
        this.$refs.zoomImg.doZoomOut();
      },
      zoomReset() {
        triggerEvent(this.$refs.zoomImg, 'wheelzoom.reset');
      },
      getItem() {
        this.$store.dispatch('alert/loadItem', { event_id: this.id })
          .then(() => {
            this.setImageSquare();
            this.notes = this.item.notes;
            this.updateImageViewerSrc(this.item.image_path);
          });
      },
      updateImageViewerSrc(path, camera, local = null) {
        if (!this.clicked[camera]) {
          this.clicked[camera] = true;
          this.imageViewerSrc = (!local ? path : require('.././assets/images/img_thermo_2.png'));
          this.zoomReset();

          // triggerEvent(this.$refs.zoomImg, 'wheelzoom.reset');
          triggerEvent(this.$refs.zoomImg, 'wheelzoom.destroy');
          setTimeout(() => {this.initZoom(); this.clicked[camera] = false; }, 2000);
        }
      },
      redirectBack() {
        this.showBackBtn = false;
        this.show = false;
        setTimeout(() => window.close(), 500);
      },
      setImageSquare() {
        this.avataRimageHeight = this.$refs.targetImg.clientHeight - 20;
        // this.$refs.avatar.clientHeight = this.$refs.targetImg.clientWidth;
      },
      updateNote() {
        const data = {
          event_id: this.item.id,
          fields: ["notes"],
          values: [this.notes]
        };

        this.$store.dispatch('alert/updateEvent', data)
          .then(() => {
            this.$snotify.success("Note successfully added.");
            this.item.notes = this.notes;
          });
      },
      flagEvent() {
        if(confirm("Are you sure you want to Flag alert?")) {
          const data = {
            event_id: this.item.id,
            fields: ["flagged"],
            values: [1]
          };

          this.$store.dispatch('alert/updateEvent', data)
            .then(() => {
              this.$snotify.success("Event successfully flagged");
              this.item.flagged = 1;
            });
        }
      },
      sendNotification() {
        if(confirm("Are you sure you want to Send notification?")) {
          this.$store.dispatch('alert/sendNotification', {event_id: this.item.id})
            .then(() => this.$snotify.success("Notification successfully sent!"));
        }
      },
      identified(state) {
        this.$snotify[state.status](state.message);

        if (state.status == 'success') {
          this.getItem();
        }
      },
      userIdentified() {
        let data = new FormData();

        data.set('event_id', this.item.id);
        data.set('user_id', this.item.user_id);

        this.axios.post(`/identify`, data).then(() => this.getItem());
        this.edit = false;
      }
    },
  };
</script>

<style scoped>
  .image-container {
    width: 100%
  }

  .first-two-footage .col-6 {
    padding-right: 0;
    padding-left: 0;
  }

  .first-two-footage .col-6 img {
    max-width: 100%;
  }

  .allert-footage-container {
    margin-left: 0;
    width: 100%;
    max-width: 100%;
  }

  #zoomContainer {
    height: 100%;
  }

  .allert-footage-container img {
    max-width: 100% !important;
    max-height: auto !important;
  }
</style>
